import { isBefore } from "date-fns";
import jwt from "jsonwebtoken";
import get from "lodash-es/get";

// If an accessToken exists, that means the phone was verified.
export function getAccessToken({
  accessTokens,
  groupId,
}: {
  accessTokens: { [groupId: string]: string };
  groupId: null | number;
}): null | string {
  // It's normal for this clause to get hit while config is loading.
  // This fn handles this scenario gracefully but returning null until we have a groupId
  if (!groupId) {
    return null;
  }
  // We typecast to a string because it is saved that way when we JSON.stringify the object
  const accessToken =
    accessTokens && accessTokens[String(groupId)]
      ? accessTokens[String(groupId)]
      : null;

  if (!accessToken) {
    return null;
  }

  try {
    const now = new Date();
    const decoded = jwt.decode(accessToken);
    const dateDecoded = get(decoded, "exp") || 0;

    if (isBefore(now, dateDecoded * 1000)) {
      return accessToken;
    }
    return null; // access token is expired
  } catch (err) {
    console.error(err);
    return null;
  }
}
